import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { AggregateBusinessFilterProperty, FilterType, ForecastTimelineFilterProperty } from '@/coreDomainsModule/entities/filter';
import BaseSelectInput from './BaseSelectInput.vue';
import { FilterInfoState } from './interface/uiState';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { ref, watch } from 'vue';
import { FilterModalType } from '../filterModal/filterModal';


export default /*@__PURE__*/_defineComponent({
  __name: 'SingleSelectInput',
  props: {
    index: {},
    modelValue: {},
    placeholder: {},
    label: {},
    disabled: { type: Boolean },
    filterType: {},
    isOpenProp: { type: Boolean },
    propAggregateBusinessFilterProperty: { default: undefined },
    propCustomerForecastFilterProperty: { default: undefined },
    propOptions: { default: () => [] as string[] },
    propPagingState: { default: undefined },
    propPagingOptions: { default: undefined },
    isError: { type: Boolean },
    errorMessage: { default: '' },
    useTeleport: { type: Boolean },
    filterModalType: { default: 'deletion-business' }
  },
  emits: ["click:selectInput", "update:modelValue", "update:valueWithIndex", "click:seeMore", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedRepresent = ref<string>(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    selectedRepresent.value = props.modelValue;
  }
);

/**
 * 選択されたオプションを親コンポーネントに通知します。
 * @param option - 選択されたオプション
 * @param index - 選択されたオプションのインデックス
 */
const selectOption = (option: string, index?: number) => {
  selectedRepresent.value = option;
  emit('update:modelValue', option);
  if (index != undefined) emit('update:valueWithIndex', option, index);
  emit('close');
};

/**
 * オプションをリセットします。
 */
const resetOption = () => {
  selectedRepresent.value = '';
  emit('update:modelValue', '');
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSelectInput, {
    index: _ctx.index,
    "selected-represent": selectedRepresent.value,
    placeholder: _ctx.placeholder,
    label: _ctx.label,
    disabled: _ctx.disabled,
    "filter-type": _ctx.filterType,
    "is-open-prop": _ctx.isOpenProp,
    "prop-aggregate-business-filter-property": _ctx.propAggregateBusinessFilterProperty,
    "prop-customer-forecast-filter-property": _ctx.propCustomerForecastFilterProperty,
    "prop-options": _ctx.propOptions,
    "prop-original-options": _ctx.propOptions,
    "prop-paging-state": _ctx.propPagingState,
    "prop-paging-options": _ctx.propPagingOptions,
    "is-error": _ctx.isError,
    "error-message": _ctx.errorMessage,
    "use-teleport": _ctx.useTeleport,
    "onClick:selectInput": _cache[0] || (_cache[0] = () => _ctx.$emit('click:selectInput')),
    onReset: resetOption,
    onUpdate: _cache[1] || (_cache[1] = (e, index) => selectOption(e, index)),
    "onClick:seeMore": _cache[2] || (_cache[2] = () => _ctx.$emit('click:seeMore')),
    onClose: _cache[3] || (_cache[3] = () => _ctx.$emit('close'))
  }, null, 8, ["index", "selected-represent", "placeholder", "label", "disabled", "filter-type", "is-open-prop", "prop-aggregate-business-filter-property", "prop-customer-forecast-filter-property", "prop-options", "prop-original-options", "prop-paging-state", "prop-paging-options", "is-error", "error-message", "use-teleport"]))
}
}

})